import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import { KEY_LABEL_PAY, KEY_LABEL_PAYMENT_CANCEL, KEY_LABEL_PAYMENT_FAILED, KEY_LABEL_PAYMENT_SUCC, KEY_LABEL_RETURN_INDI, KEY_LABEL_VAL_ADDED, MODULE_PAYMENT } from "config/const/locale";

function AfterPayment(props) {

    const { t } = useTranslation(MODULE_PAYMENT)
    const [msg, setMsg] = React.useState('')
    const [searchParam, setSearchParam] = useSearchParams()

    const getTypeText = () => {
        switch (searchParam.get('type')) {
            case 'purchase':
                return t(KEY_LABEL_PAY)
            case 'recharge':
                return t(KEY_LABEL_VAL_ADDED)

            default:
                return t(KEY_LABEL_PAY)
        }
    }

    const getI18nMsg = () => {
        switch (props?.msg) {
            case "成功":
                return t(KEY_LABEL_PAYMENT_SUCC)
            case "失敗":
                return t(KEY_LABEL_PAYMENT_FAILED)
            case "取消":
                return t(KEY_LABEL_PAYMENT_CANCEL)

            default:
                return t(KEY_LABEL_PAYMENT_SUCC)
        }
    }

    React.useEffect(() => {
        setMsg(getTypeText() + getI18nMsg())
    }, [])

    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
            }}
        >
            <Stack position={'absolute'} top={'20%'} left={'50%'} display={'flex'} justifyContent={'center'} alignItems={'center'}
                spacing={2}
            >
                <Typography variant="h4">{msg}</Typography>
                <Button variant="outlined"><Link to={'/individualAcc'}>{t(KEY_LABEL_RETURN_INDI)}</Link></Button>
            </Stack>
        </Box>
    );
}

export default React.memo(AfterPayment)
